import { t } from "ttag";

import S from "./SkipLink.module.css";

/**
 * Visually hidden until keyboard-focused. Lets keyboard/screen-reader users
 * jump straight past the app bar and sidebar to the main content, instead of
 * tabbing through every navigation item on every page load.
 */
export function SkipLink() {
  return (
    <nav aria-label={t`Skip links`}>
      <a href="#main-content" className={S.skipLink}>
        {t`Skip to main content`}
      </a>
    </nav>
  );
}
